import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchExpenseBillList = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        commit('resetExpenseBillOutstandingList')
        axios.post('/expenseBill/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            if(res.data.try_again) {
                dispatch('fetchExpenseBillList', payload)
            } else {
                commit('setExpenseBillList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})                 
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchExpenseBillData = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/expenseBill/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            
            commit('setExpenseBillData', {response: res.data.response, copy: payload.copy})   
            dispatch('fetchDocumentList', {expense_bill_id: payload.id})     
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetExpenseBillData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitExpenseBillData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/expenseBill/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {    
            
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchExpenseBillData', {id: res.data.id})
            }            
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteExpenseBillData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/expenseBill/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack && !payload.popup) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else if(payload.popup) {
            } else {
                dispatch('fetchExpenseBillList', payload.list)
            }
            
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/expenseBill/actions.js